import type {SagaIterator} from 'redux-saga';
import {FULFILLED, PENDING} from 'redux-promise-middleware';
import {prop} from 'ramda';

import {CATEGORY} from 'constants/actions';

import {all, call, select, take, takeEvery} from 'redux-saga/effects';
import {getCategory, getTotalItemsCount} from 'selectors/category/category';
import {getActiveFilters} from 'selectors/filters/filters';
import {createGAEvent, analytics} from 'libs/analytics/analytics';

/**
 * Send filters analytics
 */
export function* sendFiltersAnalytics() {
    const prevCategory = yield select(getCategory);

    yield all([
        take(`${CATEGORY.GET_CATEGORY}_${FULFILLED}`),
        take(`${CATEGORY.GET_FILTERS_CATEGORY}_${FULFILLED}`),
        take(`${CATEGORY.GET_CATEGORY_ITEMS}_${FULFILLED}`),
    ]);

    const [category, activeFilters, categoryItemsCount] = yield all([
        select(getCategory),
        select(getActiveFilters),
        select(getTotalItemsCount),
    ]);

    const filters = Object.keys(activeFilters)
        .map(key => `${key}:${activeFilters[key].map(item => item.value).join(',')}`)
        .join(';');

    if (prop('id', prevCategory) !== prop('id', category)) {
        const event = yield call(createGAEvent, {
            category: `category filters applied - ${prop('title', category)}`,
            action: `filters applied - ${filters || 'none'}`,
            label: categoryItemsCount,
        });

        yield call(analytics, event, true);
    }
}

/**
 * Category saga
 */
export function* categoryGASaga(): SagaIterator<> {
    yield takeEvery(`${CATEGORY.GET_CATEGORY}_${PENDING}`, sendFiltersAnalytics);
}
